import { render, staticRenderFns } from "./AddThreadModal.vue?vue&type=template&id=f40f5d86&scoped=true"
import script from "./AddThreadModal.vue?vue&type=script&lang=ts"
export * from "./AddThreadModal.vue?vue&type=script&lang=ts"
import style0 from "./AddThreadModal.vue?vue&type=style&index=0&id=f40f5d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40f5d86",
  null
  
)

export default component.exports